import VideoBaseController from "./video_base_controller"

// Example: Simple video URL validator - extends VideoBaseController
// Usage: data-controller="video-url-validator"
// Use case: Just validate video URLs without preview functionality
export default class extends VideoBaseController {
  static targets = ["urlInput", "validationMessage"]

  validateUrl(event) {
    const url = this.cleanVideoUrl(event.target.value)
    const validation = this.validateVideoUrl(url)
    
    if (validation.valid) {
      this.showSuccess(`Valid ${this.getPlatform(validation.url).toUpperCase()} URL`)
      event.target.classList.remove('is-invalid')
      event.target.classList.add('is-valid')
    } else {
      if (url) { // Only show error if user entered something
        this.showError(validation.error)
        event.target.classList.remove('is-valid')
        event.target.classList.add('is-invalid')
      } else {
        this.clearValidation()
        event.target.classList.remove('is-valid', 'is-invalid')
      }
    }
  }

  showSuccess(message) {
    this.setValidationMessage(message, 'text-success small mt-1')
  }

  showError(message) {
    this.setValidationMessage(message, 'text-danger small mt-1')
  }

  clearValidation() {
    this.setValidationMessage('', '')
  }

  setValidationMessage(message, className) {
    if (this.hasValidationMessageTarget) {
      this.validationMessageTarget.textContent = message
      this.validationMessageTarget.className = className
    }
  }
}